export enum EmailTemplateVisibility {
  Global = "global",
  Organizational = "organizational",
  Personal = "personal",
}

export enum EmailBrandingId {
  None = -1,
  Default,
}

export enum EmailAliasType {
  Primary = "primary",
  Alias = "alias",
  Whitelabel = "whitelabel",
  GmailAlias = "gmail_alias",
  GmailPrimary = "gmail_primary",
}

export enum DynamicFieldModalType {
  Resume = "link.resume",
  Widget = "link.widget",
}
